  <mat-card>
      <mat-card-header>
          <mat-card-title>Dettaglio catalogo</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">

        <form [formGroup]="registerForm" (ngSubmit)="save()">


          <mat-form-field [style.display]="getConfigurazione().Codice" class="example-full-width">
                    <mat-label class="text-sm">Codice</mat-label>
                    <input matInput placeholder="Codice" formControlName="Codice" name="Codice" >
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Nome" class="example-full-width">
                    <mat-label class="text-sm">Nome</mat-label>
                    <input matInput placeholder="Nome" formControlName="Nome" name="Nome" >
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Descrizione" class="example-full-width">
                    <mat-label class="text-sm">Descrizione</mat-label>
                    <input matInput placeholder="Descrizione" formControlName="Descrizione" name="Descrizione" >
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Datavalidodal" class="example-full-width">
                    <mat-label class="text-sm">Valido dal</mat-label>
                    <input matInput [matDatepicker]="startpicker"
                      placeholder="Data valido dal"
                      formControlName="Datavalidodal"
                      name="Datavalidodal" >
                    <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                    <mat-datepicker #startpicker startView="month" ></mat-datepicker>
          </mat-form-field>
    <!--            (dateChange)="onStartDateChange($event)"  era nel campo sopra-->
          <mat-form-field [style.display]="getConfigurazione().Datavalidoal" class="example-full-width">
                    <mat-label class="text-sm">Valido al</mat-label>
                    <input matInput [matDatepicker]="endpicker"

                      placeholder="Data valido al"
                      formControlName="Datavalidoal"
                      name="Datavalidoal" >
                    <mat-datepicker-toggle matIconSuffix [for]="endpicker">
            <!--          <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon> -->
                    </mat-datepicker-toggle>
                    <mat-datepicker #endpicker startView="month"></mat-datepicker>
          </mat-form-field>
          <!--                       [min]="minEndDate"
                                [matDatepickerFilter]="endDateFilter" era nel campo sopra-->

          <mat-form-field [style.display]="getConfigurazione().Categoria" class="example-full-width">
                    <mat-label class="text-sm">Categoria</mat-label>
                    <input matInput placeholder="Categoria" formControlName="Categoria" name="Categoria" >
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codicefornitore" class="example-full-width">
                    <mat-label class="text-sm">Codicefornitore</mat-label>
                    <input matInput placeholder="Codicefornitore" formControlName="Codicefornitore" name="Codicefornitore" >
          </mat-form-field>





        </form>
      </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
